module.exports = __webpack_public_path__ + "static/media/id-card-bg.3c26bc6d.jpg";